var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgToday = function SvgToday(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 53.51,
    r: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.56 14.23h-5.99V9.61a4.61 4.61 0 1 0-9.22 0v4.6H68.38v-4.6a4.61 4.61 0 1 0-9.22 0v4.6H38.42v-4.6a4.61 4.61 0 1 0-9.22 0v4.6h-5.76C13.249 14.221 4.994 22.489 5 32.68v71.9c.017 10.176 8.264 18.419 18.44 18.43H58.7a4.61 4.61 0 1 0 0-9.22H23.44a9.23 9.23 0 0 1-9.22-9.22v-71.9a9.23 9.23 0 0 1 9.22-9.22h5.76v4.6a4.61 4.61 0 1 0 9.22 0v-4.6h20.74v4.6a4.61 4.61 0 1 0 9.22 0v-4.6h20.97v4.6a4.61 4.61 0 1 0 9.22 0v-4.6h6a9.23 9.23 0 0 1 9.21 9.22v26.27a4.61 4.61 0 1 0 9.22 0V32.67c-.011-10.18-8.26-18.429-18.44-18.44"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 53.51,
    r: 4.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 73.51,
    r: 4.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 73.51,
    r: 4.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 73.51,
    r: 4.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 53.51,
    r: 4.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 73.51,
    r: 4.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 93.51,
    r: 4.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 93.51,
    r: 4.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.51,
    r: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.951 103.21a4 4 0 0 1 5.51-.22l.146.136 8.688 8.435 23.656-22.924a4 4 0 0 1 5.513-.05l.143.14a4 4 0 0 1 .05 5.513l-.139.142-29.227 28.323-14.256-13.839a4 4 0 0 1-.084-5.656"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgToday);
export default ForwardRef;